import { useAsyncData, useRouteParams } from '#imports'

import { getAsyncDataKey } from '@backmarket/nuxt-module-http-v2/getAsyncDataKey'
import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'

export function useFetchCustomerTestingReport() {
  const { orderlinePublicId } = useRouteParams()
  const $httpFetch = useHttpFetch()

  const { data, status, error, refresh } = useAsyncData(
    getAsyncDataKey('customer-testing-report', { orderlinePublicId }),
    () =>
      $httpFetch('/api/testing-reports/v1/customer-facing-reports', {
        query: { orderlinePublicId },
      }),
  )

  return { report: data, status, error, refresh }
}
